import React from 'react';
import { Badge, Nav } from 'react-bootstrap';
import { fileTabVal } from './sideTypes';
import styles from './fileTabButton.module.css';

type FileTabButtonProperties = {
    setMenuState: (state: fileTabVal) => void;
    stateValue: fileTabVal;
    setValue: fileTabVal;
    icon: string;
    title: string;
    showNew?: boolean;
    disable?: boolean;
    buttonStyle?: React.CSSProperties;
    external?: {
        newTab?: boolean;
        url?: string;
        adImage?: string;
    }
}

function fileTabClasses(stateValue: fileTabVal, setValue: string): string {
    if (stateValue === setValue) {
        return styles.tab + " " + styles.active;
    }
    return styles.tab
}

export const FileTabButton = (props: FileTabButtonProperties) => {

    return (
        <Nav.Item className={fileTabClasses(props.stateValue, props.setValue)} 
                  onClick={() => (props.external && props.external.url) ? window.open(props.external.url, props.external.newTab ? '_blank' : undefined) : !props.disable && props.setMenuState(props.setValue)}
                  style={{ 
                    opacity: props.disable ? 0.5 : 1, 
                    pointerEvents: props.disable ? 'none' : 'auto',
                    ...(props.buttonStyle?.width && { width: props.buttonStyle.width }),
                    ...(props.buttonStyle?.backgroundColor && { backgroundColor: props.buttonStyle.backgroundColor })
                  }}>
            {props.external?.adImage ? <img src={props.external.adImage} alt={props.title} /> : <i className={ props.icon + " fa-action"} />}
            <span style={{ ...(props.buttonStyle?.color && { color: props.buttonStyle.color }) }}>
                {props.title}
            </span>
            { props.showNew === true && 
                <Badge pill bg="indicator" text="light" className="indicator-new">NEW</Badge>
            }
        </Nav.Item>
    )
}